function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.76 0h4.75c.32.08.64.19.96.24 14.54 2 25.37 16.05 20.3 32.73-3.23 10.62-13.44 17.39-24.74 17.01C13.3 49.63 3.82 42.02.98 31.48.63 30.16.33 28.83 0 27.5v-5c.31-1.29.58-2.59.95-3.86C3.9 8.72 10.44 2.65 20.55.43c.74-.15 1.47-.28 2.21-.43z",
  fill: "#D93175"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.02 13.57c3.72 0 4.16.01 5.63.08 1.36.06 2.1.29 2.59.48.65.25 1.11.55 1.6 1.04s.79.95 1.04 1.6c.19.49.42 1.23.48 2.59.07 1.47.08 1.91.08 5.63 0 3.72-.01 4.16-.08 5.63-.06 1.36-.29 2.1-.48 2.59-.25.65-.55 1.11-1.04 1.6s-.95.79-1.6 1.04c-.49.19-1.23.42-2.59.48-1.47.07-1.91.08-5.63.08-3.72 0-4.16-.01-5.63-.08-1.36-.06-2.1-.29-2.59-.48-.65-.25-1.11-.55-1.6-1.04s-.79-.95-1.04-1.6c-.19-.49-.42-1.23-.48-2.59-.07-1.47-.08-1.91-.08-5.63 0-3.72.01-4.16.08-5.63.06-1.36.29-2.1.48-2.59.25-.65.55-1.11 1.04-1.6s.95-.79 1.6-1.04c.49-.19 1.23-.42 2.59-.48 1.47-.06 1.91-.08 5.63-.08zm0-2.51c-3.79 0-4.26.02-5.75.08-1.48.07-2.5.3-3.38.65-.92.36-1.69.83-2.47 1.61-.77.77-1.25 1.55-1.61 2.47-.34.89-.58 1.9-.65 3.38-.07 1.49-.08 1.96-.08 5.75s.02 4.26.08 5.75c.07 1.48.3 2.5.65 3.38.36.92.83 1.69 1.61 2.47.77.77 1.55 1.25 2.47 1.61.89.34 1.9.58 3.38.65 1.49.07 1.96.08 5.75.08s4.26-.02 5.75-.08c1.48-.07 2.5-.3 3.38-.65a6.84 6.84 0 0 0 2.47-1.61c.77-.77 1.25-1.55 1.61-2.47.34-.89.58-1.9.65-3.38.07-1.49.08-1.96.08-5.75s-.02-4.26-.08-5.75c-.07-1.48-.3-2.5-.65-3.38a6.84 6.84 0 0 0-1.61-2.47 6.887 6.887 0 0 0-2.47-1.61c-.89-.34-1.9-.58-3.38-.65-1.49-.06-1.96-.08-5.75-.08z",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.02 17.84A7.16 7.16 0 0 0 17.86 25c0 3.96 3.2 7.16 7.16 7.16s7.16-3.2 7.16-7.16a7.16 7.16 0 0 0-7.16-7.16zm0 11.81c-2.57 0-4.65-2.08-4.65-4.65 0-2.57 2.08-4.65 4.65-4.65 2.57 0 4.65 2.08 4.65 4.65 0 2.57-2.08 4.65-4.65 4.65zM32.46 19.23a1.67 1.67 0 1 0 0-3.34 1.67 1.67 0 0 0 0 3.34z",
  fill: "#fff"
});

var SvgSourceInstagram = function SvgSourceInstagram(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_instagram.7ce2b957.svg";
export { ForwardRef as ReactComponent };